// Cognito username/password auth (browser SRP flow). Config comes from build-time
// Vite env; when unset, accounts are disabled and the game runs localStorage-only.
import {
  AuthenticationDetails,
  CognitoUser,
  CognitoUserPool,
} from 'amazon-cognito-identity-js';

const POOL_ID = import.meta.env.VITE_USER_POOL_ID as string | undefined;
const CLIENT_ID = import.meta.env.VITE_USER_POOL_CLIENT_ID as string | undefined;

const pool =
  POOL_ID && CLIENT_ID ? new CognitoUserPool({ UserPoolId: POOL_ID, ClientId: CLIENT_ID }) : null;

export function isConfigured(): boolean {
  return pool !== null;
}

export function currentUsername(): string | null {
  return pool?.getCurrentUser()?.getUsername() ?? null;
}

export function signUp(username: string, password: string): Promise<void> {
  return new Promise((resolve, reject) => {
    if (!pool) return reject(new Error('accounts not configured'));
    pool.signUp(username, password, [], [], (err) => (err ? reject(err) : resolve()));
  });
}

export function signIn(username: string, password: string): Promise<string> {
  return new Promise((resolve, reject) => {
    if (!pool) return reject(new Error('accounts not configured'));
    const user = new CognitoUser({ Username: username, Pool: pool });
    const details = new AuthenticationDetails({ Username: username, Password: password });
    user.authenticateUser(details, {
      onSuccess: (session) => resolve(session.getIdToken().getJwtToken()),
      onFailure: (err) => reject(err),
    });
  });
}

export function signOut(): void {
  pool?.getCurrentUser()?.signOut();
}

/** Resolve a fresh ID token for the signed-in user (refreshing if needed), or null. */
export function getIdToken(): Promise<string | null> {
  return new Promise((resolve) => {
    const user = pool?.getCurrentUser();
    if (!user) return resolve(null);
    user.getSession((err: Error | null, session: { getIdToken(): { getJwtToken(): string } } | null) => {
      if (err || !session) return resolve(null);
      resolve(session.getIdToken().getJwtToken());
    });
  });
}
